// extracted by mini-css-extract-plugin
export default {"container":"SignatureViewer_container__7ySIE","deletionIcon":"SignatureViewer_deletionIcon__6bwJs","signatureImg":"SignatureViewer_signatureImg__DzWl6"};